export const FILTROS_EXCLUIDOS_PADRAO = ['PaginaAtual', 'QuantidadePorPagina'];

export const ORDENACAO_ORDENAR_POR_KEY = 'OrdenarPor';

export const ORDENACAO_DIRECAO_KEY = 'Direcao';

export const CONFIG_PADRAO_TIMEOUT_MS = 3000;

export const COGNITO_GROUP_CONFIGURACOES_LISTAGEM_GERAL = 'configuracoes-listagem-geral';
